import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Custom gold cursor with a trailing ring. Hidden on touch devices.
export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) setEnabled(true);
    else return;

    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      const el = e.target;
      setHovering(!!el.closest("button, a, [data-cursor='hover']"));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="pointer-events-none fixed z-[200] h-2 w-2 rounded-full bg-gold"
        style={{ left: pos.x - 4, top: pos.y - 4 }}
      />
      <motion.div
        className="pointer-events-none fixed z-[200] rounded-full border border-gold/60"
        animate={{
          left: pos.x - (hovering ? 26 : 16),
          top: pos.y - (hovering ? 26 : 16),
          width: hovering ? 52 : 32,
          height: hovering ? 52 : 32,
          opacity: hovering ? 1 : 0.5,
        }}
        transition={{ type: "spring", stiffness: 200, damping: 20, mass: 0.5 }}
      />
    </>
  );
}
